module.exports = __webpack_public_path__ + "static/media/caring.b0234493.png";